import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { EnhancedDashboardPage } from './pages/EnhancedDashboardPage'
import { QueryPage } from './pages/QueryPage'
import { MarketsPage } from './pages/MarketsPage'
import { MarketDetailsPage } from './pages/MarketDetailsPage'
import { ReportsPage } from './pages/ReportsPage'
import { LoginPage } from './pages/LoginPage'
import { SettingsPage } from './pages/SettingsPage'
import { AdminPage } from './pages/AdminPage'
import { ExpansionPathwayPage } from './pages/ExpansionPathwayPage'
import SellerAnalytics from './pages/SellerAnalytics'
import MarketComparison from './pages/MarketComparison'
import AdvancedFilters from './pages/AdvancedFilters'
import BulkExport from './pages/BulkExport'
import WidgetBuilder from './pages/WidgetBuilder'
import NotificationCenter from './pages/NotificationCenter'
import AuditTrail from './pages/AuditTrail'
import UserProfile from './pages/UserProfile'
import DataImport from './pages/DataImport'
import ScheduledReports from './pages/ScheduledReports'
import LanguageSettings from './pages/LanguageSettings'
import { I18nProvider } from './contexts/I18nContext'
import { KeyboardShortcutsProvider } from './contexts/KeyboardShortcutsContext'
import AccessibilitySettings from './pages/AccessibilitySettings'
import RateLimitDashboard from './pages/RateLimitDashboard'
import CacheDashboard from './pages/CacheDashboard'
import AdvancedSearchPage from './pages/AdvancedSearchPage'
import AnnotationsPage from './pages/AnnotationsPage'
import ForecastingPage from './pages/ForecastingPage'
import APIPlaygroundPage from './pages/APIPlaygroundPage'
import TeamManagementPage from './pages/TeamManagementPage'
import ReportBuilderPage from './pages/ReportBuilderPage'
import AlertRulesPage from './pages/AlertRulesPage'
import BenchmarkPage from './pages/BenchmarkPage'
import GoalTrackingPage from './pages/GoalTrackingPage'
import DashboardSharingPage from './pages/DashboardSharingPage'
import PerformanceMonitoringPage from './pages/PerformanceMonitoringPage'
import DataLineagePage from './pages/DataLineagePage'
import WorkflowAutomationPage from './pages/WorkflowAutomationPage'
import DataCatalogPage from './pages/DataCatalogPage'
import AIChatPage from './pages/AIChatPage'
import CostCalculatorPage from './pages/CostCalculatorPage'
import IntegrationHubPage from './pages/IntegrationHubPage'
import ChangelogPage from './pages/ChangelogPage'
import FeatureFlagsPage from './pages/FeatureFlagsPage'
import DataQualityPage from './pages/DataQualityPage'
import CompetitiveIntelligencePage from './pages/CompetitiveIntelligencePage'
import CustomerSegmentationPage from './pages/CustomerSegmentationPage'
import ProductCatalogPage from './pages/ProductCatalogPage'
import EmailTemplatesPage from './pages/EmailTemplatesPage'
import UserActivityPage from './pages/UserActivityPage'
import ABTestingPage from './pages/ABTestingPage'
import SurveysPage from './pages/SurveysPage'
import KnowledgeBasePage from './pages/KnowledgeBasePage'
import APIUsagePage from './pages/APIUsagePage'
import MultiTenantPage from './pages/MultiTenantPage'
import SSOConfigPage from './pages/SSOConfigPage'
import WebhookManagerPage from './pages/WebhookManagerPage'
import TagManagementPage from './pages/TagManagementPage'
import BackupDashboardPage from './pages/BackupDashboardPage'
import SystemHealthPage from './pages/SystemHealthPage'
import MigrationManagerPage from './pages/MigrationManagerPage'
import APIVersioningPage from './pages/APIVersioningPage'
import LocalizationPage from './pages/LocalizationPage'
import ModerationPage from './pages/ModerationPage'
import TicketingPage from './pages/TicketingPage'
import BillingPage from './pages/BillingPage'
import SubscriptionPage from './pages/SubscriptionPage'
import ReferralPage from './pages/ReferralPage'
import AuditCompliancePage from './pages/AuditCompliancePage'
import SLAMonitoringPage from './pages/SLAMonitoringPage'
import ResourceAnalyticsPage from './pages/ResourceAnalyticsPage'
import CustomDomainsPage from './pages/CustomDomainsPage'
import WhitelabelPage from './pages/WhitelabelPage'
import MarketplacePage from './pages/MarketplacePage'
import RatePlansPage from './pages/RatePlansPage'
import DataExportPage from './pages/DataExportPage'
import ComplianceReportingPage from './pages/ComplianceReportingPage'
import UsagePricingPage from './pages/UsagePricingPage'
import VersionControlPage from './pages/VersionControlPage'
import EmailCampaignsPage from './pages/EmailCampaignsPage'
import PredictiveAnalyticsPage from './pages/PredictiveAnalyticsPage'
import DocumentManagementPage from './pages/DocumentManagementPage'
import TeamCollaborationPage from './pages/TeamCollaborationPage'
import WorkflowBuilderPage from './pages/WorkflowBuilderPage'
import MultiTenancyPage from './pages/MultiTenancyPage'
import SystemHealthDashboardPage from './pages/SystemHealthDashboardPage'
import APIGatewayPage from './pages/APIGatewayPage'
import DataWarehousePage from './pages/DataWarehousePage'
import NotificationsHubPage from './pages/NotificationsHubPage'
import CustomerPortalPage from './pages/CustomerPortalPage'
import RevenueAnalyticsPage from './pages/RevenueAnalyticsPage'
import InventoryManagementPage from './pages/InventoryManagementPage'
import OrderProcessingPage from './pages/OrderProcessingPage'
import ShippingLogisticsPage from './pages/ShippingLogisticsPage'
import PaymentGatewayPage from './pages/PaymentGatewayPage'
import LoyaltyProgramPage from './pages/LoyaltyProgramPage'
import ReturnsRefundsPage from './pages/ReturnsRefundsPage'
import SupplierManagementPage from './pages/SupplierManagementPage'
import AffiliatesPage from './pages/AffiliatesPage'
import AssetManagementPage from './pages/AssetManagementPage'
import ExpenseManagementPage from './pages/ExpenseManagementPage'
import ContractsPage from './pages/ContractsPage'
import EventsPage from './pages/EventsPage'
import ResourceBookingPage from './pages/ResourceBookingPage'
import SocialMediaPage from './pages/SocialMediaPage'
import SEOAnalyticsPage from './pages/SEOAnalyticsPage'
import TrainingPage from './pages/TrainingPage'
import FleetManagementPage from './pages/FleetManagementPage'
import ProjectsPage from './pages/ProjectsPage'
import CRMPage from './pages/CRMPage'
import TimeTrackingPage from './pages/TimeTrackingPage'
import BudgetsPage from './pages/BudgetsPage'
import RisksPage from './pages/RisksPage'
import QualityPage from './pages/QualityPage'
import ProcurementPage from './pages/ProcurementPage'
import LegalPage from './pages/LegalPage'
import HRPage from './pages/HRPage'
import PayrollPage from './pages/PayrollPage'
import LeavePage from './pages/LeavePage'
import PerformancePage from './pages/PerformancePage'
import RecruitmentPage from './pages/RecruitmentPage'
import VisitorsPage from './pages/VisitorsPage'
import IncidentsPage from './pages/IncidentsPage'
import KnowledgePage from './pages/KnowledgePage'
import CommunicationsPage from './pages/CommunicationsPage'
import CalendarPage from './pages/CalendarPage'
import FacilitiesPage from './pages/FacilitiesPage'
import EquipmentPage from './pages/EquipmentPage'
import SafetyPage from './pages/SafetyPage'
import EnergyPage from './pages/EnergyPage'
import ParkingPage from './pages/ParkingPage'
import MailroomPage from './pages/MailroomPage'
import CateringPage from './pages/CateringPage'
import RoomsPage from './pages/RoomsPage'
import TravelPage from './pages/TravelPage'
import WellnessPage from './pages/WellnessPage'
import ServiceDeskPage from './pages/ServiceDeskPage'
import DocumentsPage from './pages/DocumentsPage'
import ClientsPage from './pages/ClientsPage'
import MarketingPage from './pages/MarketingPage'
import ELearningPage from './pages/ELearningPage'
import BIPage from './pages/BIPage'
import DataLakePage from './pages/DataLakePage'
import MLPipelinePage from './pages/MLPipelinePage'
import RevenueIntelPage from './pages/RevenueIntelPage'
import ExecutiveDashboardPage from './pages/ExecutiveDashboardPage'
import ServiceMeshPage from './pages/ServiceMeshPage'
import EventBusPage from './pages/EventBusPage'
import StreamProcessingPage from './pages/StreamProcessingPage'
import GraphDatabasePage from './pages/GraphDatabasePage'
import TaskSchedulerPage from './pages/TaskSchedulerPage'
import APMPage from './pages/APMPage'
import IncidentResponsePage from './pages/IncidentResponsePage'
import StatusPageManagerPage from './pages/StatusPageManagerPage'
import RunbookAutomationPage from './pages/RunbookAutomationPage'
import CostOptimizationPage from './pages/CostOptimizationPage'
import IAMPage from './pages/IAMPage'
import SecretsManagementPage from './pages/SecretsManagementPage'
import SecurityScanningPage from './pages/SecurityScanningPage'
import VulnerabilityManagementPage from './pages/VulnerabilityManagementPage'
import ComplianceTrackingPage from './pages/ComplianceTrackingPage'
import ThreatIntelligencePage from './pages/ThreatIntelligencePage'
import PenetrationTestingPage from './pages/PenetrationTestingPage'
import BugBountyPage from './pages/BugBountyPage'
import RiskAssessmentPage from './pages/RiskAssessmentPage'
import ControlTestingPage from './pages/ControlTestingPage'
import VendorManagementPage from './pages/VendorManagementPage'
import SLAManagementPage from './pages/SLAManagementPage'
import DemandForecastingPage from './pages/DemandForecastingPage'
import FinancialPlanningPage from './pages/FinancialPlanningPage'
import StrategicPlanningPage from './pages/StrategicPlanningPage'
import WorkforceIntelligencePage from './pages/WorkforceIntelligencePage'
import OperationsIntelligencePage from './pages/OperationsIntelligencePage'
import CustomerIntelligencePage from './pages/CustomerIntelligencePage'
import ProductIntelligencePage from './pages/ProductIntelligencePage'
import MarketIntelligencePage from './pages/MarketIntelligencePage'
import DataMiningPage from './pages/DataMiningPage'
import SentimentAnalysisPage from './pages/SentimentAnalysisPage'
import CohortAnalysisPage from './pages/CohortAnalysisPage'
import AttributionModelingPage from './pages/AttributionModelingPage'
import RecommendationEnginePage from './pages/RecommendationEnginePage'
import AnomalyDetectionPage from './pages/AnomalyDetectionPage'
import ABTestingAnalyticsPage from './pages/ABTestingAnalyticsPage'
import ConversionOptimizationPage from './pages/ConversionOptimizationPage'
import RealTimeAnalyticsPage from './pages/RealTimeAnalyticsPage'
import CustomerJourneyPage from './pages/CustomerJourneyPage'
import VoiceOfCustomerPage from './pages/VoiceOfCustomerPage'
import NPSTrackingPage from './pages/NPSTrackingPage'
import CustomerEffortPage from './pages/CustomerEffortPage'
import ChurnPredictionPage from './pages/ChurnPredictionPage'
import CustomerHealthPage from './pages/CustomerHealthPage'
import SupportAnalyticsPage from './pages/SupportAnalyticsPage'
import FeedbackManagementPage from './pages/FeedbackManagementPage'
import CustomerSuccessPage from './pages/CustomerSuccessPage'
import ExperienceAnalyticsPage from './pages/ExperienceAnalyticsPage'
// Phase 231-240: Revenue Operations Suite
import RevenueAnalytics2Page from './pages/RevenueAnalytics2Page'
import PricingAnalyticsPage from './pages/PricingAnalyticsPage'
import SalesPipelinePage from './pages/SalesPipelinePage'
import DealAnalyticsPage from './pages/DealAnalyticsPage'
import CommissionTrackingPage from './pages/CommissionTrackingPage'
import QuotaManagementPage from './pages/QuotaManagementPage'
import RevenueRecognitionPage from './pages/RevenueRecognitionPage'
import BillingAnalyticsPage from './pages/BillingAnalyticsPage'
import ContractIntelligencePage from './pages/ContractIntelligencePage'
import RevenueForecastingPage from './pages/RevenueForecastingPage'
// Phase 241-250: Marketing Intelligence Suite
import CampaignAnalyticsPage from './pages/CampaignAnalyticsPage'
import LeadScoringPage from './pages/LeadScoringPage'
import MarketingAttributionPage from './pages/MarketingAttributionPage'
import ContentPerformancePage from './pages/ContentPerformancePage'
import SocialAnalyticsPage from './pages/SocialAnalyticsPage'
import EmailAnalyticsPage from './pages/EmailAnalyticsPage'
import SEOPerformancePage from './pages/SEOPerformancePage'
import PPCAnalyticsPage from './pages/PPCAnalyticsPage'
import MarketingROIPage from './pages/MarketingROIPage'
import AudienceInsightsPage from './pages/AudienceInsightsPage'
// Phase 251-260: Operations Excellence Suite
import ProcessAutomationPage from './pages/ProcessAutomationPage'
import QualityManagementPage from './pages/QualityManagementPage'
import ComplianceMonitoringPage from './pages/ComplianceMonitoringPage'
import RiskManagementPage from './pages/RiskManagementPage'
import AssetTrackingPage from './pages/AssetTrackingPage'
import MaintenanceManagementPage from './pages/MaintenanceManagementPage'
import SupplyChainAnalyticsPage from './pages/SupplyChainAnalyticsPage'
import LogisticsOptimizationPage from './pages/LogisticsOptimizationPage'
import InventoryOptimizationPage from './pages/InventoryOptimizationPage'
import CapacityPlanningPage from './pages/CapacityPlanningPage'
// Phase 261-270: Data Governance Suite (DataCatalogPage, DataQualityPage, DataLineagePage already imported above)
import MasterDataPage from './pages/MasterDataPage'
import PrivacyManagementPage from './pages/PrivacyManagementPage'
import DataClassificationPage from './pages/DataClassificationPage'
import DataRetentionPage from './pages/DataRetentionPage'
import DataSecurityPage from './pages/DataSecurityPage'
import AuditTrailPage from './pages/AuditTrailPage'
import MetadataManagementPage from './pages/MetadataManagementPage'
// Phase 271-280: AI/ML Operations Suite
import ModelRegistryPage from './pages/ModelRegistryPage'
import ModelTrainingPage from './pages/ModelTrainingPage'
import ModelDeploymentPage from './pages/ModelDeploymentPage'
import ModelMonitoringPage from './pages/ModelMonitoringPage'
import FeatureStorePage from './pages/FeatureStorePage'
import ExperimentTrackingPage from './pages/ExperimentTrackingPage'
// MLPipelinePage already imported above
import AutoMLPage from './pages/AutoMLPage'
import ModelGovernancePage from './pages/ModelGovernancePage'
import MLOpsDashboardPage from './pages/MLOpsDashboardPage'
// Phase 281-290: Integration Hub Suite
import APIMarketplacePage from './pages/APIMarketplacePage'
import ConnectorLibraryPage from './pages/ConnectorLibraryPage'
import DataSyncPage from './pages/DataSyncPage'
import WebhookMgmtPage from './pages/WebhookMgmtPage'
import ETLBuilderPage from './pages/ETLBuilderPage'
import DataTransformPage from './pages/DataTransformPage'
import IntegrationMonitoringPage from './pages/IntegrationMonitoringPage'
import PartnerPortalPage from './pages/PartnerPortalPage'
import APIAnalyticsPage from './pages/APIAnalyticsPage'
import IntegrationOrchestrationPage from './pages/IntegrationOrchestrationPage'
// Phase 291-300: Executive Suite
import ExecutiveDashboardExecPage from './pages/ExecutiveDashboardExecPage'
import BoardReportingPage from './pages/BoardReportingPage'
import StrategicPlanningExecPage from './pages/StrategicPlanningExecPage'
import KPIManagementPage from './pages/KPIManagementPage'
import PerformanceScorecardsPage from './pages/PerformanceScorecardsPage'
import BusinessReviewsPage from './pages/BusinessReviewsPage'
import InvestmentAnalysisPage from './pages/InvestmentAnalysisPage'
import RiskDashboardPage from './pages/RiskDashboardPage'
import ComplianceDashboardPage from './pages/ComplianceDashboardPage'
import ExecutiveInsightsPage from './pages/ExecutiveInsightsPage'
import {
  CategoriesPage,
  SectorsPage,
  QuarterlyPage,
  SellersPage,
  GeographicPage,
  MarketPerformancePage,
  InventoryPage,
} from './pages/analytics'
import {
  ComplianceOverviewPage,
  MarketCompliancePage,
  VATCompliancePage,
  ProductStandardsPage,
  CustomsPage,
  DataProtectionPage,
  ConsumerRightsPage,
  BusinessRegistrationPage,
} from './pages/compliance'
import { ToastProvider } from './components/common/Toast'
import { ThemeProvider } from './contexts/ThemeContext'
import './styles/global.css'

// Create QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

// Simple auth check (replace with proper auth service)
const isAuthenticated = () => {
  return !!localStorage.getItem('token')
}

// Protected Route wrapper
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

// Admin Route wrapper
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (!isAuthenticated() || user.role !== 'admin') {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <I18nProvider>
          <ToastProvider>
            <Router>
              <KeyboardShortcutsProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <EnhancedDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/query"
              element={
                <ProtectedRoute>
                  <QueryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/markets"
              element={
                <ProtectedRoute>
                  <MarketsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/markets/:country"
              element={
                <ProtectedRoute>
                  <MarketDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <ReportsPage />
                </ProtectedRoute>
              }
            />

            {/* Seller Performance Analytics */}
            <Route
              path="/seller-analytics"
              element={
                <ProtectedRoute>
                  <SellerAnalytics />
                </ProtectedRoute>
              }
            />

            {/* Market Comparison Tool */}
            <Route
              path="/market-comparison"
              element={
                <ProtectedRoute>
                  <MarketComparison />
                </ProtectedRoute>
              }
            />

            {/* Advanced Filters */}
            <Route
              path="/advanced-filters"
              element={
                <ProtectedRoute>
                  <AdvancedFilters />
                </ProtectedRoute>
              }
            />

            {/* Bulk Export */}
            <Route
              path="/bulk-export"
              element={
                <ProtectedRoute>
                  <BulkExport />
                </ProtectedRoute>
              }
            />

            {/* Widget Builder */}
            <Route
              path="/widget-builder"
              element={
                <ProtectedRoute>
                  <WidgetBuilder />
                </ProtectedRoute>
              }
            />

            {/* Notification Center */}
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <NotificationCenter />
                </ProtectedRoute>
              }
            />

            {/* Audit Trail */}
            <Route
              path="/audit-trail"
              element={
                <ProtectedRoute>
                  <AuditTrail />
                </ProtectedRoute>
              }
            />

            {/* User Profile */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              }
            />

            {/* Data Import */}
            <Route
              path="/data-import"
              element={
                <ProtectedRoute>
                  <DataImport />
                </ProtectedRoute>
              }
            />

            {/* Scheduled Reports */}
            <Route
              path="/scheduled-reports"
              element={
                <ProtectedRoute>
                  <ScheduledReports />
                </ProtectedRoute>
              }
            />

            {/* Language Settings */}
            <Route
              path="/language"
              element={
                <ProtectedRoute>
                  <LanguageSettings />
                </ProtectedRoute>
              }
            />

            {/* Accessibility Settings */}
            <Route
              path="/accessibility"
              element={
                <ProtectedRoute>
                  <AccessibilitySettings />
                </ProtectedRoute>
              }
            />

            {/* Advanced Search */}
            <Route
              path="/search"
              element={
                <ProtectedRoute>
                  <AdvancedSearchPage />
                </ProtectedRoute>
              }
            />

            {/* Collaborative Annotations */}
            <Route
              path="/annotations"
              element={
                <ProtectedRoute>
                  <AnnotationsPage />
                </ProtectedRoute>
              }
            />

            {/* Predictive Analytics & Forecasting */}
            <Route
              path="/forecasting"
              element={
                <ProtectedRoute>
                  <ForecastingPage />
                </ProtectedRoute>
              }
            />

            {/* API Documentation Playground */}
            <Route
              path="/api-playground"
              element={
                <ProtectedRoute>
                  <APIPlaygroundPage />
                </ProtectedRoute>
              }
            />

            {/* Team Management */}
            <Route
              path="/teams"
              element={
                <ProtectedRoute>
                  <TeamManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Custom Report Builder */}
            <Route
              path="/report-builder"
              element={
                <ProtectedRoute>
                  <ReportBuilderPage />
                </ProtectedRoute>
              }
            />

            {/* Alert Rules Engine */}
            <Route
              path="/alert-rules"
              element={
                <ProtectedRoute>
                  <AlertRulesPage />
                </ProtectedRoute>
              }
            />

            {/* Benchmark Analytics */}
            <Route
              path="/benchmarks"
              element={
                <ProtectedRoute>
                  <BenchmarkPage />
                </ProtectedRoute>
              }
            />

            {/* Goal Tracking & KPIs */}
            <Route
              path="/goals"
              element={
                <ProtectedRoute>
                  <GoalTrackingPage />
                </ProtectedRoute>
              }
            />

            {/* Dashboard Sharing */}
            <Route
              path="/sharing"
              element={
                <ProtectedRoute>
                  <DashboardSharingPage />
                </ProtectedRoute>
              }
            />

            {/* Performance Monitoring */}
            <Route
              path="/monitoring"
              element={
                <ProtectedRoute>
                  <PerformanceMonitoringPage />
                </ProtectedRoute>
              }
            />

            {/* Data Lineage */}
            <Route
              path="/lineage"
              element={
                <ProtectedRoute>
                  <DataLineagePage />
                </ProtectedRoute>
              }
            />

            {/* Workflow Automation */}
            <Route
              path="/workflows"
              element={
                <ProtectedRoute>
                  <WorkflowAutomationPage />
                </ProtectedRoute>
              }
            />

            {/* Data Catalog */}
            <Route
              path="/catalog"
              element={
                <ProtectedRoute>
                  <DataCatalogPage />
                </ProtectedRoute>
              }
            />

            {/* AI Chat Assistant */}
            <Route
              path="/ai-chat"
              element={
                <ProtectedRoute>
                  <AIChatPage />
                </ProtectedRoute>
              }
            />

            {/* Cost Calculator & ROI Analysis */}
            <Route
              path="/cost-calculator"
              element={
                <ProtectedRoute>
                  <CostCalculatorPage />
                </ProtectedRoute>
              }
            />

            {/* Integration Hub */}
            <Route
              path="/integrations"
              element={
                <ProtectedRoute>
                  <IntegrationHubPage />
                </ProtectedRoute>
              }
            />

            {/* Changelog & Release Notes */}
            <Route
              path="/changelog"
              element={
                <ProtectedRoute>
                  <ChangelogPage />
                </ProtectedRoute>
              }
            />

            {/* Feature Flags Management */}
            <Route
              path="/feature-flags"
              element={
                <ProtectedRoute>
                  <FeatureFlagsPage />
                </ProtectedRoute>
              }
            />

            {/* Data Quality Rules Engine */}
            <Route
              path="/data-quality"
              element={
                <ProtectedRoute>
                  <DataQualityPage />
                </ProtectedRoute>
              }
            />

            {/* Competitive Intelligence */}
            <Route
              path="/competitive-intel"
              element={
                <ProtectedRoute>
                  <CompetitiveIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Customer Segmentation */}
            <Route
              path="/segments"
              element={
                <ProtectedRoute>
                  <CustomerSegmentationPage />
                </ProtectedRoute>
              }
            />

            {/* Product Catalog */}
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <ProductCatalogPage />
                </ProtectedRoute>
              }
            />

            {/* Email Templates & Campaigns */}
            <Route
              path="/email-templates"
              element={
                <ProtectedRoute>
                  <EmailTemplatesPage />
                </ProtectedRoute>
              }
            />

            {/* User Activity & Session Analytics */}
            <Route
              path="/user-activity"
              element={
                <ProtectedRoute>
                  <UserActivityPage />
                </ProtectedRoute>
              }
            />

            {/* A/B Testing Framework */}
            <Route
              path="/ab-testing"
              element={
                <ProtectedRoute>
                  <ABTestingPage />
                </ProtectedRoute>
              }
            />

            {/* Survey & Feedback System */}
            <Route
              path="/surveys"
              element={
                <ProtectedRoute>
                  <SurveysPage />
                </ProtectedRoute>
              }
            />

            {/* Knowledge Base / Help Center */}
            <Route
              path="/knowledge-base"
              element={
                <ProtectedRoute>
                  <KnowledgeBasePage />
                </ProtectedRoute>
              }
            />

            {/* API Usage Analytics */}
            <Route
              path="/api-usage"
              element={
                <ProtectedRoute>
                  <APIUsagePage />
                </ProtectedRoute>
              }
            />

            {/* Multi-Tenant Management */}
            <Route
              path="/tenants"
              element={
                <ProtectedRoute>
                  <MultiTenantPage />
                </ProtectedRoute>
              }
            />

            {/* SSO/SAML Configuration */}
            <Route
              path="/sso"
              element={
                <ProtectedRoute>
                  <SSOConfigPage />
                </ProtectedRoute>
              }
            />

            {/* Webhook Management Console */}
            <Route
              path="/webhooks"
              element={
                <ProtectedRoute>
                  <WebhookManagerPage />
                </ProtectedRoute>
              }
            />

            {/* Tag & Label Management */}
            <Route
              path="/tags"
              element={
                <ProtectedRoute>
                  <TagManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Backup & Disaster Recovery */}
            <Route
              path="/backup"
              element={
                <ProtectedRoute>
                  <BackupDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* System Health Monitoring */}
            <Route
              path="/system-health"
              element={
                <ProtectedRoute>
                  <SystemHealthPage />
                </ProtectedRoute>
              }
            />

            {/* Database Migration Manager */}
            <Route
              path="/migrations"
              element={
                <ProtectedRoute>
                  <MigrationManagerPage />
                </ProtectedRoute>
              }
            />

            {/* API Versioning */}
            <Route
              path="/api-versions"
              element={
                <ProtectedRoute>
                  <APIVersioningPage />
                </ProtectedRoute>
              }
            />

            {/* Localization Manager */}
            <Route
              path="/localization"
              element={
                <ProtectedRoute>
                  <LocalizationPage />
                </ProtectedRoute>
              }
            />

            {/* Content Moderation */}
            <Route
              path="/moderation"
              element={
                <ProtectedRoute>
                  <ModerationPage />
                </ProtectedRoute>
              }
            />

            {/* Support Ticketing */}
            <Route
              path="/tickets"
              element={
                <ProtectedRoute>
                  <TicketingPage />
                </ProtectedRoute>
              }
            />

            {/* Billing Management */}
            <Route
              path="/billing"
              element={
                <ProtectedRoute>
                  <BillingPage />
                </ProtectedRoute>
              }
            />

            {/* Subscription Management */}
            <Route
              path="/subscriptions"
              element={
                <ProtectedRoute>
                  <SubscriptionPage />
                </ProtectedRoute>
              }
            />

            {/* Referral Program */}
            <Route
              path="/referrals"
              element={
                <ProtectedRoute>
                  <ReferralPage />
                </ProtectedRoute>
              }
            />

            {/* Audit Compliance Dashboard */}
            <Route
              path="/audit-compliance"
              element={
                <ProtectedRoute>
                  <AuditCompliancePage />
                </ProtectedRoute>
              }
            />

            {/* SLA Monitoring */}
            <Route
              path="/sla-monitoring"
              element={
                <ProtectedRoute>
                  <SLAMonitoringPage />
                </ProtectedRoute>
              }
            />

            {/* Resource Usage Analytics */}
            <Route
              path="/resource-analytics"
              element={
                <ProtectedRoute>
                  <ResourceAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Custom Domain Management */}
            <Route
              path="/custom-domains"
              element={
                <ProtectedRoute>
                  <CustomDomainsPage />
                </ProtectedRoute>
              }
            />

            {/* White-label Configuration */}
            <Route
              path="/whitelabel"
              element={
                <ProtectedRoute>
                  <WhitelabelPage />
                </ProtectedRoute>
              }
            />

            {/* App Marketplace */}
            <Route
              path="/marketplace"
              element={
                <ProtectedRoute>
                  <MarketplacePage />
                </ProtectedRoute>
              }
            />

            {/* API Rate Plans */}
            <Route
              path="/rate-plans"
              element={
                <ProtectedRoute>
                  <RatePlansPage />
                </ProtectedRoute>
              }
            />

            {/* Data Export/Import Manager */}
            <Route
              path="/data-export"
              element={
                <ProtectedRoute>
                  <DataExportPage />
                </ProtectedRoute>
              }
            />

            {/* Compliance Reporting */}
            <Route
              path="/compliance-reporting"
              element={
                <ProtectedRoute>
                  <ComplianceReportingPage />
                </ProtectedRoute>
              }
            />

            {/* Usage-based Pricing Calculator */}
            <Route
              path="/usage-pricing"
              element={
                <ProtectedRoute>
                  <UsagePricingPage />
                </ProtectedRoute>
              }
            />

            {/* Version Control / Change Tracking */}
            <Route
              path="/version-control"
              element={
                <ProtectedRoute>
                  <VersionControlPage />
                </ProtectedRoute>
              }
            />

            {/* Email Campaign Manager */}
            <Route
              path="/email-campaigns"
              element={
                <ProtectedRoute>
                  <EmailCampaignsPage />
                </ProtectedRoute>
              }
            />

            {/* Predictive Analytics Dashboard */}
            <Route
              path="/predictive-analytics"
              element={
                <ProtectedRoute>
                  <PredictiveAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Document Management System */}
            <Route
              path="/document-management"
              element={
                <ProtectedRoute>
                  <DocumentManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Team Collaboration Hub */}
            <Route
              path="/team-collaboration"
              element={
                <ProtectedRoute>
                  <TeamCollaborationPage />
                </ProtectedRoute>
              }
            />

            {/* Workflow Automation Builder */}
            <Route
              path="/workflow-builder"
              element={
                <ProtectedRoute>
                  <WorkflowBuilderPage />
                </ProtectedRoute>
              }
            />

            {/* Multi-Tenancy Management */}
            <Route
              path="/multi-tenancy"
              element={
                <ProtectedRoute>
                  <MultiTenancyPage />
                </ProtectedRoute>
              }
            />

            {/* System Health Dashboard */}
            <Route
              path="/system-health-dashboard"
              element={
                <ProtectedRoute>
                  <SystemHealthDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Analytics Routes */}
            <Route
              path="/analytics/categories"
              element={
                <ProtectedRoute>
                  <CategoriesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics/sectors"
              element={
                <ProtectedRoute>
                  <SectorsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics/quarterly"
              element={
                <ProtectedRoute>
                  <QuarterlyPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics/sellers"
              element={
                <ProtectedRoute>
                  <SellersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics/geographic"
              element={
                <ProtectedRoute>
                  <GeographicPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics/market-performance"
              element={
                <ProtectedRoute>
                  <MarketPerformancePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics/inventory"
              element={
                <ProtectedRoute>
                  <InventoryPage />
                </ProtectedRoute>
              }
            />

            {/* Compliance Routes - specific routes must come before dynamic :country route */}
            <Route
              path="/compliance"
              element={
                <ProtectedRoute>
                  <ComplianceOverviewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/vat"
              element={
                <ProtectedRoute>
                  <VATCompliancePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/product-standards"
              element={
                <ProtectedRoute>
                  <ProductStandardsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/customs"
              element={
                <ProtectedRoute>
                  <CustomsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/data-protection"
              element={
                <ProtectedRoute>
                  <DataProtectionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/consumer-rights"
              element={
                <ProtectedRoute>
                  <ConsumerRightsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/business-registration"
              element={
                <ProtectedRoute>
                  <BusinessRegistrationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance/:country"
              element={
                <ProtectedRoute>
                  <MarketCompliancePage />
                </ProtectedRoute>
              }
            />

            {/* Expansion Pathway Routes */}
            <Route
              path="/expansion-pathway"
              element={
                <ProtectedRoute>
                  <ExpansionPathwayPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expansion-pathway/:storeId"
              element={
                <ProtectedRoute>
                  <ExpansionPathwayPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />

            {/* Admin routes */}
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />

            {/* Rate Limit Dashboard (Admin) */}
            <Route
              path="/admin/rate-limits"
              element={
                <AdminRoute>
                  <RateLimitDashboard />
                </AdminRoute>
              }
            />

            {/* Cache Dashboard (Admin) */}
            <Route
              path="/admin/cache"
              element={
                <AdminRoute>
                  <CacheDashboard />
                </AdminRoute>
              }
            />

            {/* Phase 81: API Gateway Management */}
            <Route
              path="/api-gateway"
              element={
                <ProtectedRoute>
                  <APIGatewayPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 82: Data Warehouse Integration */}
            <Route
              path="/data-warehouse"
              element={
                <ProtectedRoute>
                  <DataWarehousePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 83: Real-time Notifications Hub */}
            <Route
              path="/notifications-hub"
              element={
                <ProtectedRoute>
                  <NotificationsHubPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 84: Customer Portal Builder */}
            <Route
              path="/customer-portal"
              element={
                <ProtectedRoute>
                  <CustomerPortalPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 85: Revenue Analytics Dashboard */}
            <Route
              path="/revenue-analytics"
              element={
                <ProtectedRoute>
                  <RevenueAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 86: Inventory Management System */}
            <Route
              path="/inventory-management"
              element={
                <ProtectedRoute>
                  <InventoryManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 87: Order Processing System */}
            <Route
              path="/order-processing"
              element={
                <ProtectedRoute>
                  <OrderProcessingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 88: Shipping & Logistics Tracker */}
            <Route
              path="/shipping-logistics"
              element={
                <ProtectedRoute>
                  <ShippingLogisticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 89: Payment Gateway Integration */}
            <Route
              path="/payment-gateway"
              element={
                <ProtectedRoute>
                  <PaymentGatewayPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 90: Customer Loyalty Program */}
            <Route
              path="/loyalty-program"
              element={
                <ProtectedRoute>
                  <LoyaltyProgramPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 91: Returns & Refunds Management */}
            <Route
              path="/returns-refunds"
              element={
                <ProtectedRoute>
                  <ReturnsRefundsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 92: Supplier Management */}
            <Route
              path="/supplier-management"
              element={
                <ProtectedRoute>
                  <SupplierManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 93: Affiliate Program */}
            <Route
              path="/affiliates"
              element={
                <ProtectedRoute>
                  <AffiliatesPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 94: Asset Management */}
            <Route
              path="/asset-management"
              element={
                <ProtectedRoute>
                  <AssetManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 95: Expense Management */}
            <Route
              path="/expense-management"
              element={
                <ProtectedRoute>
                  <ExpenseManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 96: Contract Management */}
            <Route
              path="/contracts"
              element={
                <ProtectedRoute>
                  <ContractsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 97: Event Management */}
            <Route
              path="/events"
              element={
                <ProtectedRoute>
                  <EventsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 98: Resource Booking */}
            <Route
              path="/resource-booking"
              element={
                <ProtectedRoute>
                  <ResourceBookingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 99: Social Media Management */}
            <Route
              path="/social-media"
              element={
                <ProtectedRoute>
                  <SocialMediaPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 100: SEO Analytics */}
            <Route
              path="/seo-analytics"
              element={
                <ProtectedRoute>
                  <SEOAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 101: Training & Learning */}
            <Route
              path="/training"
              element={
                <ProtectedRoute>
                  <TrainingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 102: Fleet Management */}
            <Route
              path="/fleet"
              element={
                <ProtectedRoute>
                  <FleetManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 103: Project Management */}
            <Route
              path="/project-management"
              element={
                <ProtectedRoute>
                  <ProjectsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 104: CRM */}
            <Route
              path="/crm"
              element={
                <ProtectedRoute>
                  <CRMPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 105: Time Tracking */}
            <Route
              path="/time-tracking"
              element={
                <ProtectedRoute>
                  <TimeTrackingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 106: Budget Planning */}
            <Route
              path="/budget-planning"
              element={
                <ProtectedRoute>
                  <BudgetsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 107: Risk Management */}
            <Route
              path="/risk-management"
              element={
                <ProtectedRoute>
                  <RisksPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 108: Quality Control */}
            <Route
              path="/quality-control"
              element={
                <ProtectedRoute>
                  <QualityPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 109: Procurement */}
            <Route
              path="/procurement"
              element={
                <ProtectedRoute>
                  <ProcurementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 110: Legal & Compliance */}
            <Route
              path="/legal"
              element={
                <ProtectedRoute>
                  <LegalPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 111: HR Management */}
            <Route
              path="/hr-management"
              element={
                <ProtectedRoute>
                  <HRPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 112: Payroll */}
            <Route
              path="/payroll"
              element={
                <ProtectedRoute>
                  <PayrollPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 113: Leave Management */}
            <Route
              path="/leave-management"
              element={
                <ProtectedRoute>
                  <LeavePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 114: Performance Reviews */}
            <Route
              path="/performance-reviews"
              element={
                <ProtectedRoute>
                  <PerformancePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 115: Recruitment */}
            <Route
              path="/recruitment"
              element={
                <ProtectedRoute>
                  <RecruitmentPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 116: Visitor Management */}
            <Route
              path="/visitors"
              element={
                <ProtectedRoute>
                  <VisitorsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 117: Incident Management */}
            <Route
              path="/incidents"
              element={
                <ProtectedRoute>
                  <IncidentsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 118: Knowledge Management */}
            <Route
              path="/knowledge-management"
              element={
                <ProtectedRoute>
                  <KnowledgePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 119: Communications Hub */}
            <Route
              path="/communications"
              element={
                <ProtectedRoute>
                  <CommunicationsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 120: Calendar Management */}
            <Route
              path="/calendar-management"
              element={
                <ProtectedRoute>
                  <CalendarPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 121: Facilities Management */}
            <Route
              path="/facilities"
              element={
                <ProtectedRoute>
                  <FacilitiesPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 122: Equipment Tracking */}
            <Route
              path="/equipment-tracking"
              element={
                <ProtectedRoute>
                  <EquipmentPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 123: Safety & Compliance */}
            <Route
              path="/safety-compliance"
              element={
                <ProtectedRoute>
                  <SafetyPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 124: Energy Management */}
            <Route
              path="/energy-management"
              element={
                <ProtectedRoute>
                  <EnergyPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 125: Parking Management */}
            <Route
              path="/parking-management"
              element={
                <ProtectedRoute>
                  <ParkingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 126: Mailroom */}
            <Route
              path="/mailroom"
              element={
                <ProtectedRoute>
                  <MailroomPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 127: Catering Management */}
            <Route
              path="/catering"
              element={
                <ProtectedRoute>
                  <CateringPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 128: Room Reservations */}
            <Route
              path="/room-reservations"
              element={
                <ProtectedRoute>
                  <RoomsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 129: Corporate Travel */}
            <Route
              path="/corporate-travel"
              element={
                <ProtectedRoute>
                  <TravelPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 130: Wellness Programs */}
            <Route
              path="/wellness"
              element={
                <ProtectedRoute>
                  <WellnessPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 131: IT Service Desk */}
            <Route
              path="/service-desk"
              element={
                <ProtectedRoute>
                  <ServiceDeskPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 132: Document Management */}
            <Route
              path="/documents"
              element={
                <ProtectedRoute>
                  <DocumentsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 138: Client Portal */}
            <Route
              path="/client-portal"
              element={
                <ProtectedRoute>
                  <ClientsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 139: Marketing Campaigns */}
            <Route
              path="/marketing-campaigns"
              element={
                <ProtectedRoute>
                  <MarketingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 140: E-Learning Platform */}
            <Route
              path="/elearning"
              element={
                <ProtectedRoute>
                  <ELearningPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 141: Business Intelligence */}
            <Route
              path="/business-intelligence"
              element={
                <ProtectedRoute>
                  <BIPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 143: Data Lake Management */}
            <Route
              path="/data-lake"
              element={
                <ProtectedRoute>
                  <DataLakePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 144: ML Pipeline */}
            <Route
              path="/ml-pipeline"
              element={
                <ProtectedRoute>
                  <MLPipelinePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 147: Revenue Intelligence */}
            <Route
              path="/revenue-intelligence"
              element={
                <ProtectedRoute>
                  <RevenueIntelPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 150: Executive Dashboard */}
            <Route
              path="/executive-dashboard"
              element={
                <ProtectedRoute>
                  <ExecutiveDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 152: Service Mesh */}
            <Route
              path="/service-mesh"
              element={
                <ProtectedRoute>
                  <ServiceMeshPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 153: Event Bus */}
            <Route
              path="/event-bus"
              element={
                <ProtectedRoute>
                  <EventBusPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 155: Stream Processing */}
            <Route
              path="/stream-processing"
              element={
                <ProtectedRoute>
                  <StreamProcessingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 156: Graph Database */}
            <Route
              path="/graph-database"
              element={
                <ProtectedRoute>
                  <GraphDatabasePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 160: Task Scheduler */}
            <Route
              path="/task-scheduler"
              element={
                <ProtectedRoute>
                  <TaskSchedulerPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 161: APM (Application Performance Monitoring) */}
            <Route
              path="/apm"
              element={
                <ProtectedRoute>
                  <APMPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 166: Incident Response */}
            <Route
              path="/incident-response"
              element={
                <ProtectedRoute>
                  <IncidentResponsePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 167: Status Page Manager */}
            <Route
              path="/status-page"
              element={
                <ProtectedRoute>
                  <StatusPageManagerPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 168: Runbook Automation */}
            <Route
              path="/runbook-automation"
              element={
                <ProtectedRoute>
                  <RunbookAutomationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 170: Cost Optimization */}
            <Route
              path="/cost-optimization"
              element={
                <ProtectedRoute>
                  <CostOptimizationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 171: Identity & Access Management */}
            <Route
              path="/iam"
              element={
                <ProtectedRoute>
                  <IAMPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 172: Secrets Management */}
            <Route
              path="/secrets-management"
              element={
                <ProtectedRoute>
                  <SecretsManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 175: Security Scanning */}
            <Route
              path="/security-scanning"
              element={
                <ProtectedRoute>
                  <SecurityScanningPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 176: Vulnerability Management */}
            <Route
              path="/vulnerability-management"
              element={
                <ProtectedRoute>
                  <VulnerabilityManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 177: Compliance Tracking */}
            <Route
              path="/compliance-tracking"
              element={
                <ProtectedRoute>
                  <ComplianceTrackingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 181: Threat Intelligence */}
            <Route
              path="/threat-intelligence"
              element={
                <ProtectedRoute>
                  <ThreatIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 182: Penetration Testing */}
            <Route
              path="/penetration-testing"
              element={
                <ProtectedRoute>
                  <PenetrationTestingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 183: Bug Bounty */}
            <Route
              path="/bug-bounty"
              element={
                <ProtectedRoute>
                  <BugBountyPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 189: Risk Assessment */}
            <Route
              path="/risk-assessment"
              element={
                <ProtectedRoute>
                  <RiskAssessmentPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 190: Control Testing */}
            <Route
              path="/control-testing"
              element={
                <ProtectedRoute>
                  <ControlTestingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 191: Vendor Management */}
            <Route
              path="/vendor-management"
              element={
                <ProtectedRoute>
                  <VendorManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 193: SLA Management */}
            <Route
              path="/sla-management"
              element={
                <ProtectedRoute>
                  <SLAManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 195: Demand Forecasting */}
            <Route
              path="/demand-forecasting"
              element={
                <ProtectedRoute>
                  <DemandForecastingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 199: Financial Planning */}
            <Route
              path="/financial-planning"
              element={
                <ProtectedRoute>
                  <FinancialPlanningPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 200: Strategic Planning */}
            <Route
              path="/strategic-planning"
              element={
                <ProtectedRoute>
                  <StrategicPlanningPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 201: Workforce Intelligence */}
            <Route
              path="/workforce-intelligence"
              element={
                <ProtectedRoute>
                  <WorkforceIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 202: Operations Intelligence */}
            <Route
              path="/operations-intelligence"
              element={
                <ProtectedRoute>
                  <OperationsIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 203: Customer Intelligence */}
            <Route
              path="/customer-intelligence"
              element={
                <ProtectedRoute>
                  <CustomerIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 204: Product Intelligence */}
            <Route
              path="/product-intelligence"
              element={
                <ProtectedRoute>
                  <ProductIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 205: Market Intelligence */}
            <Route
              path="/market-intelligence"
              element={
                <ProtectedRoute>
                  <MarketIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 212: Data Mining */}
            <Route
              path="/data-mining"
              element={
                <ProtectedRoute>
                  <DataMiningPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 213: Sentiment Analysis */}
            <Route
              path="/sentiment-analysis"
              element={
                <ProtectedRoute>
                  <SentimentAnalysisPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 214: Cohort Analysis */}
            <Route
              path="/cohort-analysis"
              element={
                <ProtectedRoute>
                  <CohortAnalysisPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 215: Attribution Modeling */}
            <Route
              path="/attribution-modeling"
              element={
                <ProtectedRoute>
                  <AttributionModelingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 216: Recommendation Engine */}
            <Route
              path="/recommendation-engine"
              element={
                <ProtectedRoute>
                  <RecommendationEnginePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 217: Anomaly Detection */}
            <Route
              path="/anomaly-detection"
              element={
                <ProtectedRoute>
                  <AnomalyDetectionPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 218: A/B Testing Analytics */}
            <Route
              path="/ab-testing-analytics"
              element={
                <ProtectedRoute>
                  <ABTestingAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 219: Conversion Optimization */}
            <Route
              path="/conversion-optimization"
              element={
                <ProtectedRoute>
                  <ConversionOptimizationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 220: Real-Time Analytics */}
            <Route
              path="/real-time-analytics"
              element={
                <ProtectedRoute>
                  <RealTimeAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 221: Customer Journey Mapping */}
            <Route
              path="/customer-journey"
              element={
                <ProtectedRoute>
                  <CustomerJourneyPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 222: Voice of Customer */}
            <Route
              path="/voice-of-customer"
              element={
                <ProtectedRoute>
                  <VoiceOfCustomerPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 223: NPS Tracking */}
            <Route
              path="/nps-tracking"
              element={
                <ProtectedRoute>
                  <NPSTrackingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 224: Customer Effort Score */}
            <Route
              path="/customer-effort"
              element={
                <ProtectedRoute>
                  <CustomerEffortPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 225: Churn Prediction */}
            <Route
              path="/churn-prediction"
              element={
                <ProtectedRoute>
                  <ChurnPredictionPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 226: Customer Health */}
            <Route
              path="/customer-health"
              element={
                <ProtectedRoute>
                  <CustomerHealthPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 227: Support Analytics */}
            <Route
              path="/support-analytics"
              element={
                <ProtectedRoute>
                  <SupportAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 228: Feedback Management */}
            <Route
              path="/feedback-management"
              element={
                <ProtectedRoute>
                  <FeedbackManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 229: Customer Success */}
            <Route
              path="/customer-success"
              element={
                <ProtectedRoute>
                  <CustomerSuccessPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 230: Experience Analytics */}
            <Route
              path="/experience-analytics"
              element={
                <ProtectedRoute>
                  <ExperienceAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 231: Revenue Analytics 2 */}
            <Route
              path="/revenue-analytics-2"
              element={
                <ProtectedRoute>
                  <RevenueAnalytics2Page />
                </ProtectedRoute>
              }
            />

            {/* Phase 232: Pricing Analytics */}
            <Route
              path="/pricing-analytics"
              element={
                <ProtectedRoute>
                  <PricingAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 233: Sales Pipeline */}
            <Route
              path="/sales-pipeline"
              element={
                <ProtectedRoute>
                  <SalesPipelinePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 234: Deal Analytics */}
            <Route
              path="/deal-analytics"
              element={
                <ProtectedRoute>
                  <DealAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 235: Commission Tracking */}
            <Route
              path="/commission-tracking"
              element={
                <ProtectedRoute>
                  <CommissionTrackingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 236: Quota Management */}
            <Route
              path="/quota-management"
              element={
                <ProtectedRoute>
                  <QuotaManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 237: Revenue Recognition */}
            <Route
              path="/revenue-recognition"
              element={
                <ProtectedRoute>
                  <RevenueRecognitionPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 238: Billing Analytics */}
            <Route
              path="/billing-analytics"
              element={
                <ProtectedRoute>
                  <BillingAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 239: Contract Intelligence */}
            <Route
              path="/contract-intelligence"
              element={
                <ProtectedRoute>
                  <ContractIntelligencePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 240: Revenue Forecasting */}
            <Route
              path="/revenue-forecasting"
              element={
                <ProtectedRoute>
                  <RevenueForecastingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 241: Campaign Analytics */}
            <Route
              path="/campaign-analytics"
              element={
                <ProtectedRoute>
                  <CampaignAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 242: Lead Scoring */}
            <Route
              path="/lead-scoring"
              element={
                <ProtectedRoute>
                  <LeadScoringPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 243: Marketing Attribution */}
            <Route
              path="/marketing-attribution"
              element={
                <ProtectedRoute>
                  <MarketingAttributionPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 244: Content Performance */}
            <Route
              path="/content-performance"
              element={
                <ProtectedRoute>
                  <ContentPerformancePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 245: Social Analytics */}
            <Route
              path="/social-analytics"
              element={
                <ProtectedRoute>
                  <SocialAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 246: Email Analytics */}
            <Route
              path="/email-analytics"
              element={
                <ProtectedRoute>
                  <EmailAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 247: SEO Performance */}
            <Route
              path="/seo-performance"
              element={
                <ProtectedRoute>
                  <SEOPerformancePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 248: PPC Analytics */}
            <Route
              path="/ppc-analytics"
              element={
                <ProtectedRoute>
                  <PPCAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 249: Marketing ROI */}
            <Route
              path="/marketing-roi"
              element={
                <ProtectedRoute>
                  <MarketingROIPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 250: Audience Insights */}
            <Route
              path="/audience-insights"
              element={
                <ProtectedRoute>
                  <AudienceInsightsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 251: Process Automation */}
            <Route
              path="/process-automation"
              element={
                <ProtectedRoute>
                  <ProcessAutomationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 252: Quality Management */}
            <Route
              path="/quality-management"
              element={
                <ProtectedRoute>
                  <QualityManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 253: Compliance Monitoring */}
            <Route
              path="/compliance-monitoring"
              element={
                <ProtectedRoute>
                  <ComplianceMonitoringPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 254: Risk Management */}
            <Route
              path="/risk-management"
              element={
                <ProtectedRoute>
                  <RiskManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 255: Asset Tracking */}
            <Route
              path="/asset-tracking"
              element={
                <ProtectedRoute>
                  <AssetTrackingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 256: Maintenance Management */}
            <Route
              path="/maintenance-management"
              element={
                <ProtectedRoute>
                  <MaintenanceManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 257: Supply Chain Analytics */}
            <Route
              path="/supply-chain-analytics"
              element={
                <ProtectedRoute>
                  <SupplyChainAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 258: Logistics Optimization */}
            <Route
              path="/logistics-optimization"
              element={
                <ProtectedRoute>
                  <LogisticsOptimizationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 259: Inventory Optimization */}
            <Route
              path="/inventory-optimization"
              element={
                <ProtectedRoute>
                  <InventoryOptimizationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 260: Capacity Planning */}
            <Route
              path="/capacity-planning"
              element={
                <ProtectedRoute>
                  <CapacityPlanningPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 261: Data Catalog */}
            <Route
              path="/data-catalog"
              element={
                <ProtectedRoute>
                  <DataCatalogPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 262: Data Quality */}
            <Route
              path="/data-quality"
              element={
                <ProtectedRoute>
                  <DataQualityPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 263: Data Lineage */}
            <Route
              path="/data-lineage"
              element={
                <ProtectedRoute>
                  <DataLineagePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 264: Master Data */}
            <Route
              path="/master-data"
              element={
                <ProtectedRoute>
                  <MasterDataPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 265: Privacy Management */}
            <Route
              path="/privacy-management"
              element={
                <ProtectedRoute>
                  <PrivacyManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 266: Data Classification */}
            <Route
              path="/data-classification"
              element={
                <ProtectedRoute>
                  <DataClassificationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 267: Data Retention */}
            <Route
              path="/data-retention"
              element={
                <ProtectedRoute>
                  <DataRetentionPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 268: Data Security */}
            <Route
              path="/data-security"
              element={
                <ProtectedRoute>
                  <DataSecurityPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 269: Audit Trail */}
            <Route
              path="/audit-trail"
              element={
                <ProtectedRoute>
                  <AuditTrailPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 270: Metadata Management */}
            <Route
              path="/metadata-management"
              element={
                <ProtectedRoute>
                  <MetadataManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 271: Model Registry */}
            <Route
              path="/model-registry"
              element={
                <ProtectedRoute>
                  <ModelRegistryPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 272: Model Training */}
            <Route
              path="/model-training"
              element={
                <ProtectedRoute>
                  <ModelTrainingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 273: Model Deployment */}
            <Route
              path="/model-deployment"
              element={
                <ProtectedRoute>
                  <ModelDeploymentPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 274: Model Monitoring */}
            <Route
              path="/model-monitoring"
              element={
                <ProtectedRoute>
                  <ModelMonitoringPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 275: Feature Store */}
            <Route
              path="/feature-store"
              element={
                <ProtectedRoute>
                  <FeatureStorePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 276: Experiment Tracking */}
            <Route
              path="/experiment-tracking"
              element={
                <ProtectedRoute>
                  <ExperimentTrackingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 277: ML Pipeline */}
            <Route
              path="/ml-pipeline"
              element={
                <ProtectedRoute>
                  <MLPipelinePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 278: AutoML */}
            <Route
              path="/automl"
              element={
                <ProtectedRoute>
                  <AutoMLPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 279: Model Governance */}
            <Route
              path="/model-governance"
              element={
                <ProtectedRoute>
                  <ModelGovernancePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 280: MLOps Dashboard */}
            <Route
              path="/mlops-dashboard"
              element={
                <ProtectedRoute>
                  <MLOpsDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 281: API Marketplace */}
            <Route
              path="/api-marketplace"
              element={
                <ProtectedRoute>
                  <APIMarketplacePage />
                </ProtectedRoute>
              }
            />

            {/* Phase 282: Connector Library */}
            <Route
              path="/connector-library"
              element={
                <ProtectedRoute>
                  <ConnectorLibraryPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 283: Data Sync */}
            <Route
              path="/data-sync"
              element={
                <ProtectedRoute>
                  <DataSyncPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 284: Webhook Management */}
            <Route
              path="/webhook-mgmt"
              element={
                <ProtectedRoute>
                  <WebhookMgmtPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 285: ETL Builder */}
            <Route
              path="/etl-builder"
              element={
                <ProtectedRoute>
                  <ETLBuilderPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 286: Data Transform */}
            <Route
              path="/data-transform"
              element={
                <ProtectedRoute>
                  <DataTransformPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 287: Integration Monitoring */}
            <Route
              path="/integration-monitoring"
              element={
                <ProtectedRoute>
                  <IntegrationMonitoringPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 288: Partner Portal */}
            <Route
              path="/partner-portal"
              element={
                <ProtectedRoute>
                  <PartnerPortalPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 289: API Analytics */}
            <Route
              path="/api-analytics"
              element={
                <ProtectedRoute>
                  <APIAnalyticsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 290: Integration Orchestration */}
            <Route
              path="/integration-orchestration"
              element={
                <ProtectedRoute>
                  <IntegrationOrchestrationPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 291: Executive Dashboard (Exec Suite) */}
            <Route
              path="/executive-dashboard-exec"
              element={
                <ProtectedRoute>
                  <ExecutiveDashboardExecPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 292: Board Reporting */}
            <Route
              path="/board-reporting"
              element={
                <ProtectedRoute>
                  <BoardReportingPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 293: Strategic Planning (Exec Suite) */}
            <Route
              path="/strategic-planning-exec"
              element={
                <ProtectedRoute>
                  <StrategicPlanningExecPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 294: KPI Management */}
            <Route
              path="/kpi-management"
              element={
                <ProtectedRoute>
                  <KPIManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 295: Performance Scorecards */}
            <Route
              path="/performance-scorecards"
              element={
                <ProtectedRoute>
                  <PerformanceScorecardsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 296: Business Reviews */}
            <Route
              path="/business-reviews"
              element={
                <ProtectedRoute>
                  <BusinessReviewsPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 297: Investment Analysis */}
            <Route
              path="/investment-analysis"
              element={
                <ProtectedRoute>
                  <InvestmentAnalysisPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 298: Risk Dashboard */}
            <Route
              path="/risk-dashboard"
              element={
                <ProtectedRoute>
                  <RiskDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 299: Compliance Dashboard */}
            <Route
              path="/compliance-dashboard"
              element={
                <ProtectedRoute>
                  <ComplianceDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Phase 300: Executive Insights */}
            <Route
              path="/executive-insights"
              element={
                <ProtectedRoute>
                  <ExecutiveInsightsPage />
                </ProtectedRoute>
              }
            />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
              </KeyboardShortcutsProvider>
            </Router>
          </ToastProvider>
        </I18nProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App
